export enum ButtonVariant {
	Dark = "Dark",
	White = "White",
	Outlined = "Outlined",
	Subcategory = "Subcategory",
	OutlinedWhite = "OutlinedWhite",
}
